import axiosInstance from './axiosInstance';

// Free-text area/postcode/address -> { lat, lng } (centers the map).
export const geocodeAddress = (q) =>
    axiosInstance.get(`/InstallsMap/Geocode?q=${encodeURIComponent(q)}`);

// Installed (Active) customers within radiusKm of a point.
export const getNearbyInstalls = (lat, lng, radiusKm = 10) =>
    axiosInstance.get(`/InstallsMap/Nearby?lat=${lat}&lng=${lng}&radiusKm=${radiusKm}`);

// Super Admin — geocode Active-sale customers that have no coordinates yet, so newly
// added installs get pinned. Runs in the background; poll getInstallsBackfillStatus.
export const runInstallsBackfill = () => axiosInstance.post('/InstallsMap/Backfill');
export const getInstallsBackfillStatus = () => axiosInstance.get('/InstallsMap/BackfillStatus');
